import { render, staticRenderFns } from "./BbvaFormF2.vue?vue&type=template&id=bccf4f52"
import script from "./BbvaFormF2.vue?vue&type=script&lang=js"
export * from "./BbvaFormF2.vue?vue&type=script&lang=js"
import style0 from "./BbvaFormF2.vue?vue&type=style&index=0&id=bccf4f52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports